"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RestrictedValuationStepDefinition = void 0;
const WidgetStepPlugin_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPlugin");
const TemplateTypes_1 = require("../../Enum/TemplateTypes");
const configs_1 = require("../../configs/configs");
const WidgetStepPluginDefinition_1 = require("auto-widget-framework/src/Plugin/WidgetStep/WidgetStepPluginDefinition");
const StepTypes_1 = require("../../Enum/StepTypes");
const InchcapeBaseEvents_1 = require("../../Enum/InchcapeBaseEvents");
class RestrictedValuationStep extends WidgetStepPlugin_1.default {
    /**
     * @inheritDoc
     */
    getTemplate() {
        return this.widgetConfig.getTemplate(TemplateTypes_1.TemplateTypes.RESTRICTED_VALUATION_STEP)
            .getTemplate();
    }
    registerHandlers() {
        super.registerHandlers();
        const container = document.getElementById(this.widgetConfig.getContainerId());
        container.querySelector(configs_1.configs.elementIDs.maxValuationsAcknowledge)
            .addEventListener("click", () => {
            this.eventContext.emit(InchcapeBaseEvents_1.InchcapeBaseEvents.CLOSE_ERROR);
            this.eventContext.emit(InchcapeBaseEvents_1.InchcapeBaseEvents.CLOSE);
        });
    }
}
exports.default = RestrictedValuationStep;
exports.RestrictedValuationStepDefinition = new WidgetStepPluginDefinition_1.default({
    id: StepTypes_1.StepTypes.RESTRICTED_VALUATION,
    class: RestrictedValuationStep,
    priority: 0,
    linear: false
});
